module.exports = __webpack_public_path__ + "img/paragraphEle.72da961f.svg";